import { Label as LabelPrimitive } from 'radix-ui';
import { twMerge } from 'tailwind-merge';

import type { LabelProps } from './types';

function Label({ className, ...props }: LabelProps) {
  return (
    <LabelPrimitive.Root
      data-slot="label"
      className={twMerge(
        'text-c-card-muted block items-center gap-2 text-sm text-[0.6875rem] leading-tight font-normal tracking-[0.16px] select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        className
      )}
      {...props}
    />
  );
}

export { Label };
